import type { ReactNode } from 'react';
import logo from '../../assets/logo_news_factory.svg';

type Props = {
    children?: ReactNode;
};

export function ModalHeader({ children }: Props) {
    return (
        <div className={'flex flex-col w-full items-center pb-6 border-b border-light-gray mt-4'}>
            <img
                src={logo}
                className={`w-[200px] max-w-[250px] h-full ${children ? 'mb-14' : ''}`}
                alt="Logo Newsfactory"
                loading="lazy"
            />
            {children && <p className="text-heavy text-dark-gray font-super-heavy">{children}</p>}
        </div>
    );
}
